import styled from '@emotion/styled';
import { theme } from '../core/theme';
import { tokens } from '../core/tokens';
import { typography } from '../core/utils';

export const DetailsPanel = {
   Container: styled.div`
      margin-top: ${tokens.space.lg};
      border: ${tokens.border.thin} ${theme.colors.border.default};
      border-radius: ${tokens.radius.md};
      background-color: ${theme.colors.bg.secondary};
      overflow: hidden;
   `,

   Header: styled.div`
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: ${tokens.space.sm} ${tokens.space.md};
      background-color: ${theme.colors.bg.tertiary};
      border-bottom: ${tokens.border.thin} ${theme.colors.border.subtle};
   `,

   Title: styled.span`
      ${typography.bodyM}
      font-weight: ${tokens.font.weight.semibold};
      color: ${theme.colors.text.primary};
   `,

   CloseButton: styled.button`
      background: none;
      border: none;
      cursor: pointer;
      padding: ${tokens.space.xs};
      opacity: 0.6;
      color: ${theme.colors.text.secondary};
      display: flex;
      align-items: center;

      &:hover {
         opacity: 1;
      }
   `,

   Content: styled.div`
      padding: ${tokens.space.md};
   `,

   Grid: styled.div`
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: ${tokens.space.md};

      @media (max-width: 600px) {
         grid-template-columns: 1fr;
      }
   `,

   Section: styled.div`
      background-color: ${theme.colors.bg.primary};
      border: ${tokens.border.thin} ${theme.colors.border.subtle};
      border-radius: ${tokens.radius.sm};
      overflow: hidden;
   `,

   SectionHeader: styled.div`
      padding: ${tokens.space.sm} ${tokens.space.md};
      background-color: ${theme.colors.bg.secondary};
      border-bottom: ${tokens.border.thin} ${theme.colors.border.subtle};
   `,

   SectionTitle: styled.span`
      ${typography.bodyS}
      font-weight: ${tokens.font.weight.semibold};
      color: ${theme.colors.text.secondary};
      text-transform: uppercase;
      letter-spacing: 0.5px;
   `,

   SectionContent: styled.div`
      padding: ${tokens.space.sm} ${tokens.space.md};
   `,

   Row: styled.div`
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: ${tokens.space.xs};
      ${typography.bodyM}
      &:last-child {
         margin-bottom: 0;
      }
   `,

   Label: styled.span`
      color: ${theme.colors.text.secondary};
      flex-shrink: 0;
   `,

   Value: styled.span`
      color: ${theme.colors.text.primary};
      font-weight: ${tokens.font.weight.semibold};
      text-align: right;
      margin-left: ${tokens.space.md};
      word-break: break-word;
   `,

   EmptyMessage: styled.div`
      text-align: center;
      padding: ${tokens.space.lg};
      color: ${theme.colors.text.tertiary};
      ${typography.bodyM}
   `,
};
